export default "__VITE_ASSET__DaRwAiVk__"